
export const text = `[ID: A photo of an open door. Behind it, there is a brick wall.]




`